import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ShareIcon from '../../../Icons/Share';
import { DesktopDeviationSharePopup } from '../../../SharePopup';
import StatLayout from '../StatLayout';
import BiClickLogger from '../../../biLogger/BiClickClogger';
import { BiEventType, BiDataHook } from '../../../biLogger/constants';
import { MobileContext } from '../../../Context';
export var ShareStat = function (_a) {
    var deviation = _a.deviation, onClick = _a.onClick;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    return (React.createElement(BiClickLogger, { eventData: {
            evid: BiEventType.CLICK_SHARE,
        } },
        React.createElement(StatLayout, { name: "share", title: t('actionbar.share'), icon: ShareIcon, tooltip: isMobile
                ? undefined
                : {
                    renderPopover: function () { return (React.createElement(DesktopDeviationSharePopup, { deviation: deviation })); },
                    positionOnly: true,
                    tooltipKey: 'actionbar.shareDeviation',
                }, isDisabled: !deviation.isShareable, onClick: isMobile ? function () { return onClick(deviation); } : undefined, dataHook: BiDataHook.DEVIATION_SHARE_BUTTON })));
};
ShareStat.displayName = 'ShareStat';
export default ShareStat;
//# sourceMappingURL=ShareStat.js.map